import type { CSSProperties } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { navItemsFor, navIndexFor } from './nav-items';
import { setNavDirection } from './pageTransition';
import { useFlag } from '../api/flags';

export function BottomNav() {
  const { pathname } = useLocation();
  const wardrobeOn = useFlag('wardrobe');
  const navItems = navItemsFor(wardrobeOn);
  const active = navIndexFor(pathname, wardrobeOn);

  return (
    <nav aria-label="Main" className="nav-bar">
      {/* ONE plate for the whole dock, rather than a `::before` on each tab. A per-tab plate can
          only appear and disappear; a single one can travel, which is the whole point. Rendered
          only when a tab actually owns the route — on a land or a profile no tab is current, and
          a plate parked under a tab that is not lit would be a lie. */}
      {active >= 0 && (
        <span className="nav-plate" aria-hidden="true" style={{ '--nav-active': active } as CSSProperties} />
      )}
      {navItems.map(({ to, label, Glyph, paged }, index) => (
        <NavLink
          key={to}
          to={to}
          className="nav-item"
          viewTransition={paged}
          onClick={() => setNavDirection(active, paged ? index : active)}
        >
          <Glyph />
          <span>{label}</span>
        </NavLink>
      ))}
    </nav>
  );
}
